module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat-locked-2ce4ac26f299b12808f7117e2eb6538f.svg";